import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams,useNavigate } from 'react-router-dom';
import { getDataFromAPI } from '../../../../HandleAPICalls/actions';
import PostBillsComponent from './component';

const PostBillsContainer = ({ getDataFromAPI }) => {
  const { billId,franchiseeId } = useParams();
   const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [postBillData, setPostBillData] = useState({
    activeBills: [],
    closedBills: []
  });


const viewInactiveBillDetails = (billId) =>{
    navigate(`/home/configuration/partner/bills/view-past-bill-details/${billId}`)
}

  const fetchBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/partner/${franchiseeId}/bills`,
      'GET',
      undefined,
      (response) => {
        setPostBillData(response);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching bill:', err);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchBillData();
  }, [billId]);
  const handleGoBack = () => navigate(-1);

  return (
    <PostBillsComponent 
      activeBills={postBillData.activeBills}
      closedBills={postBillData.closedBills}
      loading={loading}
      handleGoBack={handleGoBack}
      viewInactiveBillDetails={viewInactiveBillDetails}
    />
  );
};

export default connect(null, { getDataFromAPI })(PostBillsContainer);